/* Geurvinder UI helpers: icons, formatting, live Shopify data adapter, question set, script loader. */
(function () {
  'use strict';
  var E = window.GeurvinderEngine;

  var ICONS = {
    sun: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M5.3 18.7l1.6-1.6M17.1 6.9l1.6-1.6"/></svg>',
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M19.5 14.6A7.8 7.8 0 0 1 9.4 4.5a7.8 7.8 0 1 0 10.1 10.1z"/></svg>',
    both: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="7.5"/><path d="M12 4.5a7.5 7.5 0 0 0 0 15z" fill="currentColor"/></svg>',
    spray: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="6.5" y="9.5" width="10" height="12" rx="3"/><path d="M9.5 9.5V6.5h4v3M13.5 6.5h2.5M19 4.5h.01M20.6 6.8h.01M19 9h.01"/></svg>',
    drop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M12 3.5c3.6 4.3 6 7.5 6 10.4a6 6 0 0 1-12 0c0-2.9 2.4-6.1 6-10.4z"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8.5" width="17" height="4" rx="1"/><path d="M5 12.5v8h14v-8M12 8.5v12M12 8.5C10.5 5 7 4.5 7 6.5S10 8.5 12 8.5zM12 8.5c1.5-3.5 5-4 5-2s-3 2-5 2z"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function moneyFmt(cfg) {
    var cur = cfg.currency || 'EUR', loc = cfg.locale || 'nl-NL';
    var full, round;
    try {
      full = new Intl.NumberFormat(loc, { style: 'currency', currency: cur });
      round = new Intl.NumberFormat(loc, { style: 'currency', currency: cur, maximumFractionDigits: 0, minimumFractionDigits: 0 });
    } catch (e) {
      full = { format: function (n) { return '€' + n.toFixed(2).replace('.', ','); } };
      round = { format: function (n) { return '€' + Math.round(n); } };
    }
    return function (cents, whole) { return (whole ? round : full).format((Number(cents) || 0) / 100); };
  }

  function bottle(color) {
    return '<svg class="gv-bottle" viewBox="0 0 100 100" aria-hidden="true">' +
      '<rect x="43" y="12" width="14" height="11" rx="2" fill="' + color + '" opacity=".55"/>' +
      '<rect x="46" y="22" width="8" height="8" fill="' + color + '" opacity=".4"/>' +
      '<rect x="27" y="29" width="46" height="58" rx="14" fill="' + color + '" opacity=".85"/>' +
      '<rect x="34" y="37" width="6" height="40" rx="3" fill="#fff" opacity=".35"/></svg>';
  }

  // ---------- default adapter: live Shopify storefront ----------
  function getPage(base, page) {
    return fetch(base + '&page=' + page, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-geurvinder-data[^>]*>([\s\S]*?)<\/script>/);
        if (!m) throw new Error('Geurvinder: data section missing');
        return JSON.parse(m[1]);
      });
  }
  var liveAdapter = {
    load: function (url) {
      var key = 'geurvinder:v1:' + url;
      try {
        var hit = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (hit && Date.now() - hit.t < 30 * 60 * 1000) return Promise.resolve(hit.items);
      } catch (e) { /* storage unavailable */ }
      var base = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=geurvinder-data&sort_by=best-selling';
      return getPage(base, 1).then(function (first) {
        var pages = Math.min(Number(first.pages) || 1, 24), rest = [];
        for (var p = 2; p <= pages; p++) rest.push(getPage(base, p));
        return Promise.all(rest).then(function (others) {
          var items = first.items.slice();
          others.forEach(function (o) { items = items.concat(o.items); });
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), items: items })); } catch (e) { /* full */ }
          return items;
        });
      });
    },
    addToCart: function (variantId, btn, cfg) {
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { id: variantId, quantity: 1 };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
      }
      return fetch((cfg.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok || res.d.status) throw new Error(res.d.description || res.d.message || 'Add to cart failed');
          if (cart && typeof cart.renderContents === 'function' && res.d.sections) {
            cart.classList.remove('is-empty');
            cart.renderContents(res.d);
          } else {
            window.location.href = cfg.cartUrl || '/cart';
          }
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'geurvinder', productVariantId: variantId, cartData: res.d });
          }
        });
    },
    // Translated title, link, type and notes of one product, for visitors on /de/, /en/, ... (null on failure)
    details: function (u, cfg) {
      var root = cfg.root || '/';
      if (root === '/' || !u) return Promise.resolve(null);
      var key = 'geurvinder:d1:' + root + u;
      try {
        var hit = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (hit) return Promise.resolve(hit);
      } catch (e) { /* storage unavailable */ }
      return fetch(root + u + '?section_id=geurvinder-data', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html.match(/<script[^>]*data-geurvinder-data[^>]*>([\s\S]*?)<\/script>/);
          var d = m ? JSON.parse(m[1]).items[0] : null;
          if (d) { try { sessionStorage.setItem(key, JSON.stringify(d)); } catch (e) { /* full */ } }
          return d || null;
        })
        .catch(function () { return null; });
    },
    track: function (name, data) {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) { /* ignore */ }
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) { /* ignore */ }
    }
  };

  // gift = true: same questions, worded for someone buying a present (gender picks the pronoun).
  // T = translated strings (section locales); cfg.text = optional overrides from the theme editor.
  function buildSteps(cfg, money, gift, gender) {
    var T = cfg.t || {}, X = cfg.text || {};
    var who = gender === 'him' ? '_him' : gender === 'her' ? '_her' : '_them';
    var L = (Number(cfg.budgetLow) || 15) * 100, H = (Number(cfg.budgetHigh) || 30) * 100;
    var steps = [
      { id: 'gender', short: T.k_gender, title: gift ? T.q_gender_gift : (X.gender || T.q_gender), options: [
        { v: 'him', l: gift ? T.o_him_gift : T.o_him, h: T.h_him },
        { v: 'her', l: gift ? T.o_her_gift : T.o_her, h: T.h_her },
        { v: 'any', l: T.o_any, h: gift ? T.h_any_gift : T.h_any }
      ] },
      { id: 'fams', short: T.k_fams, multi: 2, title: gift ? T['q_fams' + who] : (X.fams || T.q_fams),
        sub: gift ? T.s_fams_gift : T.s_fams,
        options: E.GROUP_ORDER.map(function (g) { return { v: g, l: T['f_' + g], h: T['fh_' + g], swatch: E.GROUPS[g].color }; }) },
      { id: 'moment', short: T.k_moment, title: gift ? T['q_moment' + who] : (X.moment || T.q_moment), options: [
        { v: 'dag', l: T.o_day, h: T.h_day, icon: 'sun' },
        { v: 'avond', l: T.o_eve, h: T.h_eve, icon: 'moon' },
        { v: 'altijd', l: T.o_both, h: T.h_both, icon: 'both' }
      ] }
    ];
    if (cfg.askForm) {
      steps.push({ id: 'form', short: T.k_form, title: X.form || T.q_form, sub: gift ? T.s_form_gift : '', options: [
        { v: 'spray', l: T.o_spray, h: T.h_spray, icon: 'spray' },
        { v: 'olie', l: T.o_oil, h: T.h_oil, icon: 'drop' },
        { v: 'any', l: T.o_any, h: T.h_form_any }
      ] });
    }
    steps.push({ id: 'budget', short: T.k_budget, title: gift ? T.q_budget_gift : (X.budget || T.q_budget), options: [
      { v: 'low', l: fmt(T.o_low, { x: money(L, true) }) },
      { v: 'mid', l: fmt(T.o_mid, { x: money(L, true), y: money(H, true) }) },
      { v: 'high', l: fmt(T.o_high, { x: money(H, true) }) },
      { v: 'any', l: T.o_any }
    ] });
    return steps;
  }

  // "Vraag {i} van {n}" + { i: 1, n: 5 }
  function fmt(s, vars) {
    return String(s == null ? '' : s).replace(/\{(\w)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; });
  }
  // Liquid's t filter HTML-escapes translations; the UI escapes again when it renders, so decode them once.
  var ENT = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&#x27;': "'", '&#34;': '"' };
  function decode(T) {
    var out = {};
    Object.keys(T || {}).forEach(function (k) {
      out[k] = String(T[k] == null ? '' : T[k]).replace(/&(amp|lt|gt|quot|#39|#x27|#34);/g, function (m) { return ENT[m]; });
    });
    return out;
  }
  // Product data is always loaded from the shop's default language, so matching works the same in every language.
  // root = routes.root_url of the visitor ("/" or "/de"); base() drops it, local() adds it.
  function base(url, root) {
    if (!url || !root || root === '/') return url;
    return url === root ? '/' : url.indexOf(root + '/') === 0 ? url.slice(root.length) : url;
  }
  function local(url, root) {
    if (!url || !root || root === '/' || url.charAt(0) !== '/' || url.indexOf(root + '/') === 0) return url;
    return root + url;
  }

  // Loads a classic script once (the reference perfume list is only needed for the search box).
  var scripts = {};
  function loadScript(src) {
    if (!src) return Promise.resolve();
    if (!scripts[src]) {
      scripts[src] = new Promise(function (resolve) {
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = s.onerror = function () { resolve(); };
        document.head.appendChild(s);
      });
    }
    return scripts[src];
  }

  window.GeurvinderUI = { ICONS: ICONS, esc: esc, moneyFmt: moneyFmt, bottle: bottle, liveAdapter: liveAdapter, buildSteps: buildSteps, loadScript: loadScript, fmt: fmt, decode: decode, base: base, local: local };
})();